import axios from "axios";
import { networkTimeoutThreshold } from "./config";
import { logException } from "./error-reporting";
//import { getBaseUrl } from "../../components/common/getEnv";
import { BASEURL } from "../constants/env-resolver";
const client = axios.create({});
let custId = "";
const url = BASEURL;
export default (endpoint, payload = {}, method = "get", headers = {}) => {
  const axiosConfig = {
    headers,
    method: method.toLowerCase(),
    timeout: networkTimeoutThreshold,
  };
  if (method === "get") {
    axiosConfig.params = payload;
  } else {
    axiosConfig.data = payload;
  }
  if (endpoint.includes("https://")) {
    return client(endpoint, axiosConfig);
  }
  return client(`${url}${endpoint}`, axiosConfig);
};
